import React from 'react';

const PATHS = {
  plus: 'M12 5v14M5 12h14',
  receipt: 'M6 3h12v18l-2-1.5L14 21l-2-1.5L10 21l-2-1.5L6 21V3zM9 8h6M9 12h6',
  payment: 'M4 8h16v8H4zM4 11h16M8 15h3',
  calendar: 'M5 5h14v14H5zM5 9h14M9 3v4M15 3v4',
  clear: 'M4 7h16M9 7V5h6v2M8 7l1 12h6l1-12',
  search: 'M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14zM20 20l-3.2-3.2',
  print: 'M7 8V4h10v4M7 16H5a1 1 0 0 1-1-1v-5h16v5a1 1 0 0 1-1 1h-2M7 14h10v6H7z',
};

export function ActionIcon({ name }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={d} />
    </svg>
  );
}
